import { render, staticRenderFns } from "./PeopleHistogram.vue?vue&type=template&id=92958a8a&scoped=true"
import script from "./PeopleHistogram.vue?vue&type=script&lang=ts"
export * from "./PeopleHistogram.vue?vue&type=script&lang=ts"
import style0 from "./PeopleHistogram.vue?vue&type=style&index=0&id=92958a8a&prod&lang=css"
import style1 from "./PeopleHistogram.vue?vue&type=style&index=1&id=92958a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92958a8a",
  null
  
)

export default component.exports